import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import api, { img } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { SectionTitle } from "@/components/Bits";

export default function Artisans() {
  const { t, L } = useLang();
  const [artisans, setArtisans] = useState([]);
  const [cats, setCats] = useState([]);
  const [cat, setCat] = useState("all");

  useEffect(() => {
    api.get("/artisans").then((r) => setArtisans(r.data)).catch(() => {});
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  const shown = artisans.filter((a) => cat === "all" || a.category === cat);
  const usedCats = cats.filter((c) => artisans.some((a) => a.category === c.name_zh));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
      <SectionTitle tag="ARTISANS · 手作达人" title={t("artisans_title")} />

      {usedCats.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-8">
          <button onClick={() => setCat("all")} className={`fk-border rounded-full px-4 py-2 text-sm font-semibold ${cat === "all" ? "bg-black text-white" : "bg-white fk-lift"}`}>{t("all")}</button>
          {usedCats.map((c) => (
            <button key={c.id} onClick={() => setCat(c.name_zh)} data-testid={`artisan-cat-${c.name_zh}`} className={`fk-border rounded-full px-4 py-2 text-sm font-semibold ${cat === c.name_zh ? "bg-black text-white" : "bg-white fk-lift"}`}>{L(c.name_zh, c.name_en)}</button>
          ))}
        </div>
      )}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {shown.map((a, i) => (
          <motion.div key={a.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.04 }}>
            <Link to={`/artisans/${a.slug}`} data-testid={`artisan-card-${a.id}`} className="block bg-white fk-border-thick rounded-2xl overflow-hidden fk-lift">
              <img src={img(a.photos?.[0])} alt={a.name_en} className="w-full h-52 object-cover border-b-2 border-black" />
              <div className="p-5">
                <span className="font-mono-fk text-xs fk-border rounded-full px-2.5 py-1 bg-[#00E5FF] inline-flex items-center gap-1"><Sparkles size={11} /> {a.category || t("artisans_title")}</span>
                <h3 className="font-display text-xl mt-3">{L(a.name_zh, a.name_en)}</h3>
                <p className="mt-1 text-sm text-black/60 line-clamp-2">{L(a.bio_zh, a.bio_en)}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
      {shown.length === 0 && <p className="text-black/50 font-mono-fk">暂无手作达人 / No artisans yet.</p>}
    </div>
  );
}
